module.exports = __webpack_public_path__ + "../resources/images/inline-expression-picker-574b9b965ef0119dfefb7b3126d22fce.png";